export const appConfig = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.lendingusa.com/v1',
  userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID || 'us-west-2_69LJvk8ry',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '7i8o0e622b3m3g0mu464ehb2k3',
  region: process.env.REACT_APP_COGNITO_REGION || 'us-west-2',
  identityPoolId: process.env.REACT_APP_COGNITO_IDENTITYPOOL_ID || 'us-west-2:97b9ced9-fa08-4bc3-bb8d-7472e93803cc',
  limit: process.env.REACT_APP_GRID_PAGE_LIMIT || 100,
  dscFee: 20,
  fslExportSocketUrl: 'wss://53nou9zqtj.execute-api.us-west-2.amazonaws.com/prod',
  fslExportInterval: {
    total: 1000 * 60 * 3,
  },
};



// WEBPACK FOOTER //
// ./src/config/appConfig.js